import { useTranslation } from 'react-i18next';

import UploadForm from '@components/upload/UploadForm';
import { Typography } from '@destination/components';

export default function Upload() {
  const { t } = useTranslation(undefined, { keyPrefix: 'upload_model' });

  return (
    <>
      <Typography variant="pageTitle">{t('page_title')}</Typography>
      <UploadForm />
    </>
  );
}
